/**
 * Version type color mappings for consistent styling across components
 */
export const VERSION_TYPE_BADGE_COLORS = {
  free: 'bg-green-100 text-green-800',
  trial: 'bg-blue-100 text-blue-800',
  paid: 'bg-purple-100 text-purple-800',
  demo: 'bg-orange-100 text-orange-800',
} as const

export const VERSION_TYPE_SELECT_COLORMAP = {
  free: 'bg-green-50 text-green-800 hover:!bg-green-300 hover:!text-green-900',
  trial: 'bg-blue-50 text-blue-800 hover:!bg-blue-300 hover:!text-blue-900',
  paid: 'bg-purple-50 text-purple-800 hover:!bg-purple-300 hover:!text-purple-900',
  demo: 'bg-orange-50 text-orange-800 hover:!bg-orange-300 hover:!text-orange-900',
} as const

export const getVersionTypeBadgeColor = (type: string) => {
  return VERSION_TYPE_BADGE_COLORS[type as keyof typeof VERSION_TYPE_BADGE_COLORS]
}
